// extracted by mini-css-extract-plugin
export var chevron = "_g0-2";
export var dropdownItems = "_g0-0";
export var item = "_g0-1";